function createUserProfileLoader({ supabase, onProfile, onLoading, onError }) {
  let currentUserId = null;
  let pendingRequest = null;

  const clear = () => {
    currentUserId = null;
    pendingRequest = null;
  };

  const load = async (userId) => {
    if (!userId) return { data: null, error: null, skipped: true };

    if (currentUserId === userId) {
      return pendingRequest || { data: null, error: null, skipped: true };
    }

    currentUserId = userId;
    onLoading(true);

    const request = (async () => {
      try {
        const { data, error } = await supabase
          .from('user_profiles')
          .select('*')
          .eq('id', userId)
          .maybeSingle();

        if (error) {
          if (currentUserId === userId) onError(error);
          return { data: null, error };
        }

        if (currentUserId === userId) onProfile(data);
        return { data, error: null };
      } catch (error) {
        if (currentUserId === userId) onError(error);
        return { data: null, error };
      } finally {
        if (currentUserId === userId) {
          pendingRequest = null;
          onLoading(false);
        }
      }
    })();

    pendingRequest = request;
    return request;
  };

  return { load, clear };
}

module.exports = { createUserProfileLoader };
